export default "__VITE_ASSET__BMpzk6IP__"